var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"customLogo-container"},_vm._l((_vm.data),function(item){return _c('div',{key:item.id,staticClass:"customerLogo-card"},[_c('img',{attrs:{"src":require('@/assets/img/customerLogo/' + item.src),"alt":item.title}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }